export default __webpack_public_path__ + "static/media/dohyun.2892b530.jpg";